import {connect} from 'react-redux';
import TabletScreen from '../../components/screens/TabletScreen';
import {
    startSync,
    setTimeSlot,
    setRoute,
    setSupporterAvailable,
    checkInSupporter,
    addSupporterToShift
} from '../../actions/tabletAction';

const mapStateToProps = state => {
    return {
        tabletState: state.tablet
    }
};

const mapDispatchToProps = dispatch => {
    return {
        startSync: () => {
            dispatch(startSync())
        },
        setTimeSlot: (value) => {
            dispatch(setTimeSlot(value))
        },
        setRoute: (value) => {
            dispatch(setRoute(value))
        },
        setSupporterAvailable: (supporter) => {
            dispatch(setSupporterAvailable(supporter))
        },
        checkInSupporter: (supporter, shiftId) => {
            dispatch(checkInSupporter(supporter, shiftId))
        },
        addSupporterToShift: (supporterId, shift) => {
            dispatch(addSupporterToShift(supporterId, shift))
        }
    }
};

const TabletScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TabletScreen);

export default TabletScreenContainer;